import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';

export function sortRotationsplaene(
  rotationsplaene: Rotationsplan[],
  istAufsteigend: boolean,
): Rotationsplan[] {
  if (istAufsteigend) {
    return rotationsplaene.sort((a, b) =>
      a.mitarbeiter.nachname.localeCompare(b.mitarbeiter.nachname),
    );
  } else {
    return rotationsplaene.sort((a, b) =>
      b.mitarbeiter.nachname.localeCompare(a.mitarbeiter.nachname),
    );
  }
}

export function sortRotationsplaeneByArbeitsbereich(
  rotationsplaene: KalenderArbeitsbereich[],
  istAufsteigend: boolean,
): KalenderArbeitsbereich[] {
  if (istAufsteigend) {
    return rotationsplaene.sort((a, b) => a.name.localeCompare(b.name));
  } else {
    return rotationsplaene.sort((a, b) => b.name.localeCompare(a.name));
  }
}
